var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrmLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.84712 2.81728C4.84712 3.93291 4.81899 4.84228 4.78149 4.84228C4.73462 4.83291 3.65649 4.13916 2.36274 3.29541C1.07837 2.45166 0.00961852 1.76728 0.000243525 1.77666C-0.00913148 1.79541 0.253369 2.72353 0.581494 3.85791C0.909619 4.99228 1.53774 7.18603 1.97837 8.73291C2.42837 10.2798 2.81274 11.6204 2.84087 11.7048C2.88774 11.8642 3.33774 11.8735 10.6127 11.8735H18.3284L18.4315 11.5642C18.5252 11.2735 18.9377 9.82979 20.5127 4.38291C20.9159 2.96728 21.244 1.79541 21.2252 1.78603C21.2065 1.76728 17.3815 4.24228 16.7534 4.67353C16.5846 4.80478 16.5096 4.81416 16.4534 4.72041C16.4159 4.66416 16.3877 3.77353 16.3784 2.74228C16.3784 1.71103 16.369 0.85791 16.3502 0.83916C16.3315 0.829785 15.0659 2.03916 13.5377 3.53916L10.7534 6.26728L10.4815 6.04228C10.2284 5.83603 7.13462 2.96728 5.57837 1.47666L4.84712 0.78291V2.81728Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.62842 18.0142V23.2173H10.7534H14.8784V18.0142V12.811H10.7534H6.62842V18.0142Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrmLogo);
export default __webpack_public_path__ + "static/media/crm_logo.74126e44f700b3704d11806041975911.svg";
export { ForwardRef as ReactComponent };